module.exports = __webpack_public_path__ + "img/renlian.3d1fa3d7.png";